import { RouteRecordRaw } from 'vue-router'

const categoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/category',
    meta: { requiresAuth: true },
    name: 'category layout',
    component: () => import('@/views/category/CategoryLayout.vue'),
    children: [
      {
        path: 'add',
        name: 'categoryAdd',
        component: () => import('@/components/category/AddCategory.vue'),
      },
      {
        path: ':id/edit',
        name: 'categoryEdit',
        component: () => import('@/components/category/AddCategory.vue'),
      },
      {
        path: ':invalidPath(.*)*',
        redirect: (to) => {
          return { path: '/tabs/balance' }
        },
      },
    ],
  },
]

export default categoryRoutes
